import './App.css';
import Home from './Pages/Home/Home';

function App() {
  return (
    <div className="app">
      <Home />
    </div>
  );
}

export default App;
